import logger from 'src/utils/logger/logger';
const MySongDetailAdapter = resp => {
    let result = [];

    if (!(resp && resp.response.components && Array.isArray(resp.response.components))) {
        logger.debug('La api no contiene componentes');
        return result;
    }

    resp.response.components.forEach(section => {
        if (section.type === 'GRID') {
            result = section.items.map(el => {
                let obj = {};
                obj = {
                    albumId: el.albumId || null,
                    albumName: el.albumName || '',
                    artist: el.artist || '',
                    artistId: el.artistId || null,
                    artists: el.author || null,
                    duration: el.duration || '',
                    id: el.entity_id || null,
                    image: el.img || '',
                    isFavorite: el.isFavorite || false,
                    name: el.name || '',
                    url: el.play_url || '',
                    tracking: el.tracking || null
                };
                return obj;
            });
            logger.debug('transformApiResponse');
        }
    });
    return result;
};

export default MySongDetailAdapter;



// WEBPACK FOOTER //
// ./src/components/MySongs/MySongDetailAdapter.js